import logger from '@/utils/logger'

import RPC from '@/client/rpc'

export default async function processUpload({
  userUploadId,
  timeoutSeconds = 120,
}: {
  userUploadId: number
  timeoutSeconds?: number
}) {
  await Promise.race([
    RPC.requestUserUploadPostProcessing({
      userUploadId,
    }).catch(err => {
      logger.error('Failed to request post processing in FormInputVideo', { err, userUploadId })
    }),
    new Promise(resolve => {
      setTimeout(resolve, timeoutSeconds * 1000)
    }),
  ])
}
